import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "layer-item active" }
const _hoisted_2 = {
  key: 1,
  class: "layer-label"
}
const _hoisted_3 = { class: "scroll-ring" }
const _hoisted_4 = { viewBox: "0 0 36 36" }
const _hoisted_5 = { class: "nav-pill ln-glass-elevated" }
const _hoisted_6 = {
  key: 0,
  class: "scroll-ring"
}
const _hoisted_7 = { viewBox: "0 0 36 36" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "layer-label" }
const _hoisted_10 = {
  key: 0,
  class: "scroll-ring"
}
const _hoisted_11 = { viewBox: "0 0 36 36" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (!_ctx.isPreview)
    ? (_openBlock(), _createElementBlock("nav", {
        key: 0,
        class: _normalizeClass(["layer-navigator", { 'mobile-open': _ctx.isMobileMenuOpen }])
      }, [
        (_ctx.activeItem)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "mobile-toggle ln-glass-elevated",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileMenu && _ctx.toggleMobileMenu(...args)))
            }, [
              _createElementVNode("div", _hoisted_1, [
                (_ctx.activeItem.type === 'overview')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["mdi", _ctx.activeItem.icon])
                    }, null, 2))
                  : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.activeItem.label), 1)),
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_4, [
                    _cache[2] || (_cache[2] = _createElementVNode("path", {
                      class: "ring-bg",
                      d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                    }, null, -1)),
                    _createElementVNode("path", {
                      class: "ring-progress",
                      style: _normalizeStyle({ strokeDasharray: _ctx.scrollProgress + ', 100' }),
                      d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                    }, null, 4)
                  ]))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["layer-item overview-btn", { 'active': _ctx.isActive('infrastructure') }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateTo('infrastructure')))
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "mdi mdi-view-dashboard-outline" }, null, -1)),
            (_ctx.isActive('infrastructure'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                    _cache[3] || (_cache[3] = _createElementVNode("path", {
                      class: "ring-bg",
                      d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                    }, null, -1)),
                    _createElementVNode("path", {
                      class: "ring-progress",
                      style: _normalizeStyle({ strokeDasharray: _ctx.scrollProgress + ', 100' }),
                      d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                    }, null, 4)
                  ]))
                ]))
              : _createCommentVNode("", true)
          ], 2)), [
            [
              _directive_tooltip,
              'Overview',
              void 0,
              { left: true }
            ]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "separator" }, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layers, (layer) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: layer.id,
              class: _normalizeClass(["layer-item", { 'active': _ctx.isActive(layer.route) }]),
              onClick: ($event: any) => (_ctx.navigateTo(layer.route))
            }, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(layer.label), 1),
              (_ctx.isActive(layer.route))
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_11, [
                      _cache[5] || (_cache[5] = _createElementVNode("path", {
                        class: "ring-bg",
                        d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                      }, null, -1)),
                      _createElementVNode("path", {
                        class: "ring-progress",
                        style: _normalizeStyle({ strokeDasharray: _ctx.scrollProgress + ', 100' }),
                        d: "M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                      }, null, 4)
                    ]))
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_8)), [
              [
                _directive_tooltip,
                layer.full,
                void 0,
                { left: true }
              ]
            ])
          }), 128))
        ])
      ], 2))
    : _createCommentVNode("", true)
}